import {
    GETCLUESGUID,
    DISTRIBUTIONGUID,
    GETKICKPOOL,
    CLUESSELECTEDNUM,
    CLUESSHAREDGUID,
    GETCLULEDATA,
    GEt_TRACKING_IDS,
    SHOW_TRACKING,
    SHOW_RULERIGHT,
    SHOW_RECYCLERIGHT,
    CLUES_HIGHLIGHETED,
    CLUES_TABLE_SETTING,
    CLUES_RULE_GUID,
    CLUES_RECYCLE_GUID,
    CLIENT_TABLE_SETTING
} from '../mutation-types';
const state = {
    getCluesId: { // 获取客户编号
        Guid: '',
        CustomGuid: '',
    },
    getDistributionGuid: [], // 客户分配Guid
    getTkickPool: '', // 移入公海池
    cluesSelectedNum: '', // 选中的客户条数
    cluesSharedGuid: '', // 选中客户共享guid
    getCluleData: {}, // 客户列表数据
    getTrackingIds: {}, // 跟进页ID
    isTracking: false, // 显示跟进页
    isRuleRight: false, // 分配规则侧滑
    isRecycleRight: false, // TMK分配回收侧滑
    cluesHighligheted: false, // 拨打电话时客户管理页高亮显示
    cluesTableSetting: [],
    clientTableSetting: [],
    AllocationRuleGuid: '', // 分配规则Guid
    AllocationRecycleGuid: '',
}
const getters = {}
    // 方法调用逻辑
const actions = {
    getCluesId({ commit, state, dispatch }, guid) { // 获取客户编号
        commit(GETCLUESGUID, guid);
    },
    getDistributionGuid({ commit, state, dispatch }, guid) { // 客户分配Guid
        commit(DISTRIBUTIONGUID, guid);
    },
    getTkickPool({ commit, state, dispatch }, tkick) { // 移入公海池
        commit(GETKICKPOOL, tkick);
    },
    cluesSelectedNum({ commit, state, dispatch }, num) { // 选中的客户条数
        commit(CLUESSELECTEDNUM, num);
    },
    cluesSharedGuid({ commit, state, dispatch }, id) { // 选中客户共享guid
        commit(CLUESSHAREDGUID, id);
    },
    getCluleData({ commit, state, dispatch }, data) { // 客户列表数据
        commit(GETCLULEDATA, data);
    },
    getTrackingIds({ commit, state, dispatch }, data) { // 跟进页ID
        commit(GEt_TRACKING_IDS, data);
    },
    isTracking({ commit, state, dispatch }, flag) { // 显示跟进页
        commit(SHOW_TRACKING, flag);
    },
    isRuleRight({ commit, state, dispatch }, flag) {
        commit(SHOW_RULERIGHT, flag);
    },
    isRecycleRight({ commit, state, dispatch }, flag) {
        commit(SHOW_RECYCLERIGHT, flag);
    },
    cluesHighligheted({ commit, state, dispatch }, guid) {
        commit(CLUES_HIGHLIGHETED, guid);
    },
    cluesTableSetting({ commit, state, dispatch }, table) {
        commit(CLUES_TABLE_SETTING, table);
    },
    clientTableSetting({ commit, state, dispatch }, table) {
        commit(CLIENT_TABLE_SETTING, table);
    },
    AllocationRuleGuid({ commit, state, dispatch }, guid) {
        commit(CLUES_RULE_GUID, guid);
    },
    AllocationRecycleGuid({ commit, state, dispatch }, guid) {
        commit(CLUES_RECYCLE_GUID, guid);
    }
};
// 逻辑代码
const mutations = {
    [GETCLUESGUID](state, guid) { // 获取客户编号
        state.getCluesId = guid;
    },
    [DISTRIBUTIONGUID](state, guid) { // 客户分配Guid
        state.getDistributionGuid = guid;
    },
    [GETKICKPOOL](state, tk) { // 移入公海池
        state.getTkickPool = tk;
    },
    [CLUESSELECTEDNUM](state, num) { // 选中的客户条数
        state.cluesSelectedNum = num;
    },
    [CLUESSHAREDGUID](state, id) { // 选中客户共享guid
        state.cluesSharedGuid = id;
    },
    [GETCLULEDATA](state, id) { // 选中客户共享guid
        state.getCluleData = id;
    },
    [GEt_TRACKING_IDS](state, data) { // 跟进页ID
        state.getTrackingIds = data;
    },
    [SHOW_TRACKING](state, flag) { // 显示跟进页
        state.isTracking = flag;
    },
    [SHOW_RULERIGHT](state, flag) {
        state.isRuleRight = flag;
    },
    [SHOW_RECYCLERIGHT](state, flag) {
        state.isRecycleRight = flag;
    },
    [CLUES_HIGHLIGHETED](state, guid) {
        state.cluesHighligheted = guid;
    },
    [CLUES_TABLE_SETTING](state, table) {
        state.cluesTableSetting = table;
    },
    [CLIENT_TABLE_SETTING](state, table) {
        state.clientTableSetting = table;
    },
    [CLUES_RULE_GUID](state, guid) {
        state.AllocationRuleGuid = guid;
    },
    [CLUES_RECYCLE_GUID](state, guid) {
        state.AllocationRecycleGuid = guid;
    }
};
export default {
    state,
    getters,
    actions,
    mutations
}